import { apiClient } from '@/services/base'
import { useMutation, UseMutationResult } from '@tanstack/react-query'

import { ICreate2FARequest } from './interfaces/request'
import { ICreate2FAResponse } from './interfaces/response'

export const Create2FAService = async (
  request: ICreate2FARequest,
): Promise<ICreate2FAResponse> => {
  const response = await apiClient.post('api/login/create2FAAsync', request, {
    baseURL: process.env.NEXT_PUBLIC_API_BACKEND_URL,
  })

  return response?.data
}

export const useCreate2FAService = (): UseMutationResult<
  ICreate2FAResponse,
  Error,
  ICreate2FARequest
> => {
  return useMutation<ICreate2FAResponse, Error, ICreate2FARequest>({
    mutationFn: async (request) => {
      const response = await apiClient.post('api/login/create2FAAsync', request)

      return response.data
    },
  })
}

export type { ICreate2FARequest, ICreate2FAResponse }
